import React, { Component, PropTypes } from 'react'
import { Segment, Input, Button, Grid, Header } from 'semantic-ui-react'

import FooterComponent from '../../gallery/components/FooterComponent'
import MessageComponent from './MessageComponent'

import '../../../node_modules/semantic-ui-css/components/button.css'
import '../../../node_modules/semantic-ui-css/components/grid.css'
import '../../../node_modules/semantic-ui-css/components/header.css'
import '../../../node_modules/semantic-ui-css/components/input.css'
import '../../../node_modules/semantic-ui-css/components/segment.css'

export default class LoginForm extends Component {

  static propTypes = {
    handleErrorButton: PropTypes.func.isRequired,
    handleLogin: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    loginError: PropTypes.bool.isRequired,
    router: PropTypes.object.isRequired,
  }

  componentWillMount () {
    const { isAuthenticated, router } = this.props
    if (isAuthenticated) {
      router.push('/gallery')
    }
  }

  render () {
    const { handleLogin, handleErrorButton, loginError } = this.props
    return (
      <div>
        <Grid centered stackable columns={2} className='push'>
          <Grid.Column textAlign='center'>
            {loginError && <MessageComponent />}
            <Segment className='grey-background round-corner'>
              <Header
                as='h1'
                color='yellow'
                className='top-margin'
              >
                Interactive Gallery Portfolio
              </Header>
              <Grid centered stackable columns='equal'>
                <Grid.Row>
                  <Grid.Column>
                    <Input
                      className='full-width'
                      error={loginError}
                      placeholder='hello@jambonsw.com'
                      type='email'
                      defaultValue='hello@jambonsw.com'
                     />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      className='full-width'
                      error={loginError}
                      placeholder='password'
                      type='password'
                      defaultValue='password'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid> {/* End Input Grid */}
              <Segment basic textAlign='center'>
                <Button
                  className='
                  rounded-button'
                  color='yellow'
                  type='button'
                  onClick={handleErrorButton}
                >
                  Show Error
                </Button>
                <Button
                  className='
                  rounded-button'
                  color='yellow'
                  type='button'
                  onClick={handleLogin}
                >
                  Sign In
                </Button>
              </Segment>
            </Segment>
          </Grid.Column>
        </Grid> {/* End Login Grid */}
        <FooterComponent />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/auth/components/LoginFormComponent.js